module.exports = __webpack_public_path__ + "static/img/tojoin-text.a076b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-drive/tojoin-text.png
// module id = VGBb
// module chunks = 1